export default __webpack_public_path__ + "static/media/Mouse Click.c370eec2.mp3";